
import { faqCategories } from '../../../mocks/faqData';

interface CategoryNavProps {
  activeCategory: string;
  onCategoryChange: (id: string) => void;
  categoryCounts: Record<string, number>;
}

export default function CategoryNav({ activeCategory, onCategoryChange, categoryCounts }: CategoryNavProps) {
  return (
    <div className="sticky top-[72px] z-30 bg-stone-50/95 backdrop-blur-sm border-b border-gray-200 py-4 px-6">
      <div className="max-w-5xl mx-auto">
        <div className="flex gap-2 overflow-x-auto pb-1 scrollbar-hide">
          {faqCategories.map((cat) => (
            <button
              key={cat.id}
              onClick={() => onCategoryChange(cat.id)}
              className={`flex items-center gap-2 px-4 py-2.5 rounded-full text-sm font-medium whitespace-nowrap transition-all cursor-pointer shrink-0 ${
                activeCategory === cat.id
                  ? 'bg-emerald-800 text-white shadow-sm'
                  : 'bg-white text-gray-700 hover:bg-emerald-50 hover:text-emerald-800 border border-gray-200'
              }`}
            >
              <div className="w-4 h-4 flex items-center justify-center">
                <i className={`${cat.icon} text-sm`}></i>
              </div>
              {cat.label}
              <span
                className={`text-xs px-1.5 py-0.5 rounded-full ${
                  activeCategory === cat.id
                    ? 'bg-white/20 text-white'
                    : 'bg-gray-100 text-gray-500'
                }`}
              >
                {categoryCounts[cat.id] || 0}
              </span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
